import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminFiberProductionProcesses } from '@/api/(admin)/fiber-production-processes';
import type { AdminFiberProductionProcess } from '@/api/(admin)/fiber-production-processes/types';
import type { FiberProductionProcessesQueryInput } from '../-types';
import {
  buildFiberProductionProcessesQs,
  toFiberProductionProcessesParams,
} from '../-utils/listParams';

/** Prefix for every cache entry, so one invalidation clears list + details. */
export const fiberProductionProcessesQueryKey = [
  'admin',
  'fiber-production-processes',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function fiberProductionProcessesQueryOptions(
  input: FiberProductionProcessesQueryInput,
) {
  const params = toFiberProductionProcessesParams(input);
  return queryOptions({
    queryKey: [...fiberProductionProcessesQueryKey, 'list', params] as const,
    queryFn: () =>
      fetchAdminFiberProductionProcesses(
        buildFiberProductionProcessesQs(params),
      ),
  });
}

export function useAdminFiberProductionProcesses(
  input: FiberProductionProcessesQueryInput,
) {
  const query = useQuery(fiberProductionProcessesQueryOptions(input));
  const rows: AdminFiberProductionProcess[] = query.data?.data ?? [];
  return {
    rows,
    totalCount: query.data?.metadata?.pagination?.total ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
